import { Controller } from 'stimulus';

class OppFirstViewingController extends Controller {
  static targets = ['status', 'emailLink', 'phoneLink', 'loadingText'];

  /**
   * Fetch `update_to_follow_up` rails method
   * when "Call Now" button is clicked.
   * Opportunity goes from "New" status to "Follow-up,"
   * and the UI will be updated with the opportunity's
   * new status & contact information.
   *
   * @async
   * @returns {Promise} json status
   */
  async updateFirstViewing() {
    const { status, email, phone } = await this.updateOpportunity();

    if (status !== 204) {
      return;
    }

    this.loadingTextTarget.style.display = 'none';

    if (this.hasEmailLinkTarget) {
      this.updateEmailTarget(email);
    }

    if (this.hasPhoneLinkTarget) {
      this.updatePhoneTarget(phone);
    }

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = 'Follow-up';
    }
  }

  updatePhoneTarget(phone) {
    this.phoneLinkTarget.classList.remove('u-displayNone');
    this._updateLinkMarkup(this.phoneLinkTarget, phone, 'tel');
  }

  updateEmailTarget(email) {
    this.emailLinkTarget.classList.remove('u-displayNone');
    this._updateLinkMarkup(this.emailLinkTarget, email, 'mailto');
  }

  /**
   * Fetch `show_first_viewing` rails action when "View Info" button is clicked.
   * Opportunity is marked as viewed, but is NOT updated to "Follow-up". In addition, the UI
   * will be updated with the opportunity's contact information.
   *
   * @async
   * @returns {Promise} json status
   */
  async fetchFirstViewing() {
    const { status, email, phone } = await this._fetchOpportunity();

    if (status !== 200) {
      return;
    }

    this.loadingTextTarget.style.display = 'none';
    this._updateLinkMarkup(this.emailLinkTarget, email, 'mailto');
    this._updateLinkMarkup(this.phoneLinkTarget, phone, 'tel');
  }

  async updateOpportunity() {
    const opid = this.data.get('id');
    const metaCsrf = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = metaCsrf.getAttribute('content');
    const response = await fetch(
      `/opportunities/${opid}/update_to_follow_up.json`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-csrf-token': csrfToken,
        },
      }
    );

    return response.json();
  }

  async _fetchOpportunity() {
    const opid = this.data.get('id');
    const metaCsrf = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = metaCsrf.getAttribute('content');

    const response = await fetch(
      `/opportunities/${opid}/show_first_viewing.json`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-csrf-token': csrfToken,
        },
      }
    );

    return response.json();
  }

  _updateLinkMarkup(linkTarget, value, protocol) {
    if (linkTarget.href.replace(`${protocol}:`, '') === '') {
      linkTarget.href = `${protocol}:${value}`;
      linkTarget.insertAdjacentHTML('beforeend', value);
    }
  }
}

export default OppFirstViewingController;
